import { render, staticRenderFns } from "./vClaimsAndStatementsModal.vue?vue&type=template&id=afc5f248&scoped=true"
import script from "./vClaimsAndStatementsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vClaimsAndStatementsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vClaimsAndStatementsModal.vue?vue&type=style&index=0&id=afc5f248&prod&scoped=true&lang=css"
import style1 from "./vClaimsAndStatementsModal.vue?vue&type=style&index=1&id=afc5f248&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc5f248",
  null
  
)

export default component.exports